// extracted by mini-css-extract-plugin
export default {"form":"UpdateEventForm_form__SfUMc"};